import React from 'react';
import DeleteObject from '../../../common/poppers/DeleteObject';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ModifyCar from './ModifyCar';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ActivateObject from '../../../common/poppers/ActivateObject';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import BeenhereIcon from '@material-ui/icons/Beenhere';
import CarRow from './CarRow';
import CarKmHistory from './CarKmHistory';
import FilterListIcon from '@material-ui/icons/FilterList';
import AddIcon from '@material-ui/icons/Add';
import NewCarKmHistory from './NewCarKmHistory';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import CarConsumption from './CarConsumption';
import NewCarInsurance from './NewCarInsurance';
import CarInsuranceHistory from './CarInsuranceHistory';

export const carActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Autó módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ModifyCar  {...props} close={close} />
    },
    {
        dataDialog: "active-dialog",
        title: "Aktiválás",
        dialogTitle: "Autó aktiválása",
        icon: <CheckCircleOutlineIcon fontSize="small" color="primary" />,
        canShow: (row) => !row.active,
        actionComponent: (props, close) => <ActivateObject {...props} close={close} path={'/api/activatecar'} comp={<CarRow {...props} />} />
    },
    {
        dataDialog: "active-dialog",
        title: "Inaktiválás",
        dialogTitle: "Autó inaktiválása",
        icon: <CancelOutlinedIcon fontSize="small" color="primary" />,
        canShow: (row) => row.active,
        actionComponent: (props, close) => <ActivateObject {...props} inactive={true} close={close} path={'/api/activatecar'} comp={<CarRow {...props} />} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "new-carkmhistory-dialog",
        title: "Új km adat",
        dialogTitle: ", új km",
        dialogTitleParam: (row) => row.licenseNumber,
        icon: <AddIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <NewCarKmHistory {...props} close={close} />

    },
    {
        dataDialog: "carkmhistory-dialog",
        title: "Km történet",
        dialogTitle: " km történet",
        dialogTitleParam: (row) => row.licenseNumber,
        icon: <FilterListIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <CarKmHistory {...props} close={close} />

    },
    {
        dataDialog: "carconsumption-dialog",
        title: "Fogyasztás",
        dialogTitle: " fogyasztás",
        dialogTitleParam: (row) => row.licenseNumber,
        icon: <LocalGasStationIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <CarConsumption {...props} close={close} />

    },
    {
        divider: true,
    },
    {
        dataDialog: "new-insurance-dialog",
        title: "Új biztosítás",
        dialogTitle: " biztosítás",
        dialogTitleParam: (row) => row.licenseNumber,
        icon: <BeenhereIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <NewCarInsurance {...props} close={close} />

    },
    {
        dataDialog: "insurance-history-dialog",
        title: "Biztosítások",
        dialogTitle: " biztosítások",
        dialogTitleParam: (row) => row.licenseNumber,
        icon: <BeenhereIcon fontSize="small" color="primary" />,
        width: "lg",
        actionComponent: (props, close) => <CarInsuranceHistory {...props} close={close} />

    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Autó törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/car'} confirm={"Biztos hogy törölni szeretnéd?"} comp={<CarRow {...props} />} />
    },
]